function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { View as RNView } from 'react-native';
import noop from 'lodash/noop';
import { withTheme } from '../Theme';

const View = ({
  theme,
  onRef,
  className,
  ...props
}) => /*#__PURE__*/React.createElement(RNView, _extends({
  ref: onRef
}, theme.omit(props), {
  "data-class": className
}));

View.propTypes = {
  theme: PropTypes.shape().isRequired,
  className: PropTypes.string,
  onRef: PropTypes.func
};
View.defaultProps = {
  className: '',
  onRef: noop
};
export default withTheme('View')(View);